// extracted by mini-css-extract-plugin
export default {"root":"_1uYJvb86","preview":"_3BA6ygvt","header":"_1ORJoRO2"};